import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/usr/app/src/app/services/managed-agentic-bi/components/ManagedBIClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/assets/styles/pages.scss");
